import type {
    Fragment,
    NamespaceData,
    DataItem
} from '@wix/ambassador-document-management-fragments-v1-fragment-snapshot/types'
import _ from 'lodash'

// Fragment type without namespaceItems - represents the flattened structure
// that mapGetFragmentsStaticDataResponse produces
export interface FragmentWithoutNamespaceItems extends Omit<Fragment, 'content'> {
    content?: Record<string, Omit<NamespaceData, 'namespaceItems'> & Record<string, DataItem>>
}

// Reference for similar mapping for Pages data: bolt-ds-adapter/src/host/dtos.ts
export function mapGetFragmentsDataResponse(response: Fragment): Fragment {
    return {
        ...response,
        content: _.mapValues(response.content, namespaceData => {
            return {
                ...namespaceData,
                namespaceItems: _.mapValues(namespaceData.namespaceItems, item => {
                    if (item.metadata && item.value) {
                        item.value.metaData = item.metadata
                        delete item.metadata
                    }
                    return item
                })
            }
        })
    }
}

export function mapGetFragmentsStaticDataResponse(response: FragmentWithoutNamespaceItems): Fragment {
    return {
        ...response,
        content: _.mapValues(response.content, namespaceData => {
            return {
                namespaceItems: _.mapValues(namespaceData, item => {
                    if (item.metadata && item.value) {
                        item.value.metaData = item.metadata
                        delete item.metadata
                    }
                    return item
                })
            }
        })
    }
}
